import { Component, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AranDrawerModalService } from '@aran-client/aran-web-ui-toolkit';
import { Store } from '@ngxs/store';
import { tap } from 'rxjs';
import { StoreHelperService } from 'src/app/shared/services/store-helper/store-helper.service';
import * as apiInstructionType from 'src/app/shared/types/api-instruction.type';
import { ErrorMessages } from 'src/app/shared/utils/error-message.utils';
import { PasswordUtils } from 'src/app/shared/utils/password.utils';
import { ApiInstructionAction } from 'src/app/store/api-instruction/api-instruction.action';

@Component({
  selector: 'app-generate-api-password',
  templateUrl: './generate-api-password.component.html',
  styleUrls: ['./generate-api-password.component.scss'],
})
export class GenerateApiPasswordComponent implements OnInit {
  form!: FormGroup<any>;

  errorMessages = ErrorMessages;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private store: Store,
    private aranDrawerModalService: AranDrawerModalService,
    private storeHelperService: StoreHelperService
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      userPassword: this.formBuilder.control(null, Validators.required),
      apiPassword: this.formBuilder.control(null, [
        Validators.required,
        PasswordUtils.passwordValidator(),
      ]),
      confirmApiPassword: this.formBuilder.control(null, [
        Validators.required,
        PasswordUtils.passwordCompareValidator('apiPassword'),
      ]),
    });

    PasswordUtils.bindPasswordConfirmation(
      this.form,
      'apiPassword',
      'confirmApiPassword'
    );
  }

  onEnterPressed(): void {
    this.changePass();
  }

  changePass(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const formValue = this.form.value;

    delete formValue.confirmApiPassword;

    const body = formValue as unknown as apiInstructionType.SetApiPasswordType;

    this.storeHelperService
      .getAllDispatchAndSelect(new ApiInstructionAction.ConfigureApiPsw(body))
      .pipe(
        tap(() => {
          this.store.dispatch(new ApiInstructionAction.GetDetailInfo());
          this.form.reset();
          this.aranDrawerModalService.hide();
        })
      )
      .subscribe();
  }

  get criteriaList() {
    const password = this.form.get('apiPassword')?.value || '';
    return PasswordUtils.getCriteria(password);
  }
}
